import { ShieldOff } from 'lucide-react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { useTranslation } from 'react-i18next';

interface SettingsAccessDeniedProps {
  titleKey?: string;
  descKey?: string;
}

export function SettingsAccessDenied({
  titleKey = 'access_denied.title',
  descKey = 'access_denied.desc',
}: SettingsAccessDeniedProps) {
  const { t } = useTranslation('settings');

  return (
    <Alert className="border-muted bg-muted/30">
      <ShieldOff className="h-4 w-4 text-muted-foreground" />
      <AlertTitle className="text-foreground">{t(titleKey)}</AlertTitle>
      <AlertDescription className="text-muted-foreground">{t(descKey)}</AlertDescription>
    </Alert>
  );
}
